import styled from 'styled-components';
import Link from '@material-ui/core/Link';
import Tooltip from '@material-ui/core/Tooltip';
import { verticalScroller } from 'components/base/scroller';
import Text from 'components/base/Text';
import { increaseTooltipZIndex } from 'components/Tooltips/helpers';
import { Flex, Margin } from 'components/base/layout-components';
import PeopleEffortSummary from './PeopleEffortSummary';
import {
  getContributorName,
  getContributorAvatarAndName
} from '../services/projects.services';

const Scroll = styled.div`
  ${verticalScroller()};
  ${({ isExcluded, height }) =>
    isExcluded === 0
      ? `height: calc(${height}rem + 2px);`
      : `height: calc(${height - 2}rem + 2px);`};
`;

const PeopleEffortIteration = ({
  project,
  activeUniquePeople,
  excludedUniquePeople,
  isScrumProject
}) => {
  return (
    <Flex direction='column' width='100%'>
      <PeopleEffortSummary project={project} isIterationView={true} />

      <Scroll
        isExcluded={excludedUniquePeople.length}
        height={isScrumProject ? 33 : 27.5}
      >
        {activeUniquePeople.map(({ display_name, id }) => {
          return (
            <Flex items='center' pb='small' key={id}>
              {getContributorAvatarAndName(id, display_name)}
            </Flex>
          );
        })}
      </Scroll>
      {excludedUniquePeople.length ? (
        <Margin t='small' height='2rem'>
          <Tooltip
            classes={increaseTooltipZIndex()}
            interactive
            placement='bottom'
            title={excludedUniquePeople
              .map(({ display_name }) => getContributorName(display_name))
              .join(', ')}
          >
            <Text size='medium'>
              <Link>{excludedUniquePeople.length} excluded from project</Link>
            </Text>
          </Tooltip>
        </Margin>
      ) : null}
    </Flex>
  );
};

export default PeopleEffortIteration;
